// extracted by mini-css-extract-plugin
export default {"card":"EN","autoAlign":"FN","cardrow":"GN","cardcentered":"HN","details":"IN","imgwrapper":"JN","img":"KN","category":"LN","name":"MN","copy":"NN","detailsbtn":"ON","remove":"PN","price":"QN","netPrice":"RN","regularPrice":"SN","label":"TN"};
    if(module.hot) {
      // 1730991508927
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  